import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { requestBizum, requestRedsys } from '../store/payments';
import { resetTime } from '../store/globals';
import Loader from '../components/Loader';
import LocalRedirect from '../components/LocalRedirect';
import localSessionStorage from '../services/localSessionStorage';


class PaymentCallbackError extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let stepsBar = document.getElementsByClassName("steps");
    stepsBar[0].style.display = 'none';

    this.props.resetTime();
  }

  componentWillMount() {
    const orderData = localSessionStorage.get('order-data');
    if(orderData.payment === "bizum_tickets"){
      this.props.requestBizum(orderData.country, this.props.sessionId, this.props.showtimeVistaId, this.props.cinema_id, orderData.loyalty, orderData.payment_type, orderData.merchantOrderId, orderData.billTo, orderData.clubCarrefour);
    }else if(orderData.payment === "redsys_tickets"){
      this.props.requestRedsys(orderData.country, this.props.sessionId, this.props.showtimeVistaId, this.props.cinema_id, orderData.loyalty, orderData.payment_type, orderData.merchantOrderId, orderData.billTo, orderData.clubCarrefour);
    }
  }

  render() {
    const { isLoading, paymentResponse } = this.props.payments;

    if (paymentResponse.status_code > 0) {
      return <LocalRedirect to={{pathname: "/Error", state: {message: paymentResponse.message}}} />;
    }
    if(this.props.sessionId === null || this.props.showtimeVistaId === null || this.props.cinema_id === undefined ){
      return <LocalRedirect to={{pathname: "/Error", state: {message: "Lo sentimos, la operación no fue completada. No se aplicaron cargos a tu cuenta."}}} />;
    }

    return (
      <Fragment>
        <div className="container container--mid-large payments">
          {isLoading && <Loader />}

          <div className={isLoading ? 'blur-overlay' : ''}>
          </div>
        </div>    
      </Fragment>
    );
  }
}
const mapStateToProps = ({ ui, payments, globals, login, showtime, tickets, cards, seats, locations }) => {
  return {
    sessionId: globals.sessionId,
    showtimeVistaId: globals.showtimeVistaId,
    isMobile: ui.isMobile,
    wSize: ui.size,
    modal: ui.modal,
    movieName: showtime.movie.name,
    movieFormat: showtime.movie.language,
    movieDuration: showtime.movie.length,
    cinemaName: showtime.cinema.name,
    cinemaLat: showtime.cinema.lat,
    cinemaLng: showtime.cinema.lng,
    loginResponse: login.loginResponse,
    cinema_id: showtime.cinema.vista_id,
    paymentMethodsDisabled: showtime.showtimeInfo !== null && typeof showtime.showtimeInfo.payment_methods_disabled !== 'undefined' ? showtime.showtimeInfo.payment_methods_disabled : [],
    movieDistributor: showtime.distributor,
    withFolio: cards.folio !== null,
    isLoyalty: cards.folio !== null && typeof cards.folio.type !== 'undefined' && cards.folio.type !== 'loyalty',
    isAnnualPass: cards.folio !== null && (cards.folio.parent_code === 'pase-anual'),
    isPriceZero: tickets.total === 0,
    total: seats.seatsSelectedResponse.total_value,
    selectedTickets: tickets.selectedTickets,
    payments,
    concessions: seats.concessions_data,
    bookingFee: typeof seats.seatsSelectedResponse.booking_fee_value !== 'undefined' ? seats.seatsSelectedResponse.booking_fee_value : 0,
    isMobileOrDesktop: (ui.isMobile && ui.size >= 768 && ui.size < 1024) || !ui.isMobile,
    merchantId: locations.merchantId,
    hasSeats: seats.hasSeats,
    hasFolio: tickets.selectedTickets.some(ticket => ticket.folio !== null)
  };
};

export default connect(
  mapStateToProps, { requestBizum, requestRedsys, resetTime }
)(PaymentCallbackError);
